import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { adminApi } from "@/lib/api";
import { toast, Toaster } from "sonner";
import { Eye, EyeOff } from "lucide-react";

export default function AdminLogin() {
  const [pw, setPw] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPw, setShowPw] = useState(false);
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await adminApi.post("/admin/login", { password: pw });
      localStorage.setItem("nexon_admin_token", data.token);
      nav("/admin/submissions");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Login failed");
    } finally { setLoading(false); }
  };

  return (
    <div className="admin-shell min-h-screen flex items-center justify-center p-6">
      <Toaster richColors position="top-center" />
      <form onSubmit={submit} className="bg-white rounded-2xl shadow-xl p-10 w-full max-w-md" data-testid="admin-login-form">
        <div className="flex justify-center">
          <img src="/logos/nexon-logo.webp" alt="GC Nexon" className="h-24 w-auto object-contain" />
        </div>
        <p className="mt-3 text-sm text-slate-500 text-center">Admin console — enter your password to continue.</p>
        <div className="relative mt-8">
          <input
            data-testid="admin-login-password"
            type={showPw ? "text" : "password"}
            required
            value={pw}
            onChange={(e) => setPw(e.target.value)}
            placeholder="Admin password"
            className="w-full rounded-xl border border-slate-200 px-4 py-3 pr-12 focus:outline-none focus:ring-2 focus:ring-primary"
          />
          <button
            type="button"
            onClick={() => setShowPw((v) => !v)}
            data-testid="admin-login-password-toggle"
            aria-label={showPw ? "Hide password" : "Show password"}
            title={showPw ? "Hide password" : "Show password"}
            className="absolute right-3 top-1/2 -translate-y-1/2 inline-flex items-center justify-center w-9 h-9 rounded-lg text-slate-400 hover:text-slate-700 hover:bg-slate-100 transition-colors"
          >
            {showPw ? <EyeOff size={18} /> : <Eye size={18} />}
          </button>
        </div>
        <button data-testid="admin-login-submit" disabled={loading} className="btn-pill w-full mt-4">{loading ? "Signing in…" : "Sign in"}</button>
      </form>
    </div>
  );
}
